/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';

export default Construct.extend({

    fetch: function(params, key) {
        return new Promise((resolve, reject) => {
            can.ajax({
                method: 'GET',
                url: 'https://www.googleapis.com/customsearch/v1',
                data: params
            }).done(function(data){
                resolve({data: data, filter: key});
            }).fail(reject);
        })
    }
}, {
    /* */
});